import React, { FunctionComponent } from "react"
import { Button, Modal } from "react-bootstrap"
import "./ConfirmUpdateUserType.css"

interface Props {
    manageParentState: Function
    callParentFunction: Function
    newAccessLevelID: number
    oldAccessLevelID: number
}

const ConfirmUpdateUserType: FunctionComponent<Props> = (props) => {

    const { manageParentState, callParentFunction, newAccessLevelID, oldAccessLevelID } = props

    return (
        <div className="ConfirmUpdateUserType">
            <Modal
                id="confirm-update-user-type"
                show={true}
                backdrop="static"
                keyboard={true}
                centered={true}
                size="sm"
            >
                <Modal.Header>
                    <div className="ConfirmUpdateUserTypeHeader">
                    <span className="material-icons-outlined">warning</span>
                    <p>Changing a user's type will delete all additional responsibility areas.</p>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className="ConfirmUpdateUserTypeBody">

                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className="ConfirmUpdateUserTypeFooter">
                        <Button variant="secondary" onClick={() => manageParentState([{ key: "confirmUpdateUserType", value: false }, { key: "newAccessLevelID", value: -1 }])}>Cancel</Button>
                        <Button variant="danger" onClick={() => {
                            manageParentState([{ key: "confirmUpdateUserType", value: false }, { key: "AccessLevelID", value: newAccessLevelID }])
                            callParentFunction("updateUserType", newAccessLevelID, oldAccessLevelID )
                        }}>Proceed</Button>
                    </div>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default ConfirmUpdateUserType